import React from 'react';

const SimpleLabelInfoBox = ({ label, info }) => {
  return (
    <div className={'simple-label-info-box'}>
      <p className={'simple-label'}>{label}</p>
      <p className={'simple-info'}>{info}</p>
    </div>
  );
};

export default SimpleLabelInfoBox;
